import React from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import { requireOfferSign } from "~/require-offer-sign";

import { MeetingBookPage } from "./meeting-book-page";
import { MeetingBookSuccessPage } from "./meeting-book-success-page";
import { MeetingDetailPage } from "./meeting-detail-page";
import { MeetingsEnrolledPage } from "./meetings-enrolled-page";
import { MeetingsLayout } from "./meetings-layout";
import { MeetingsPage } from "./meetings-page";
import { RedesignMeetingsProvider } from "./redesign-meetings-context";

export function MeetingsRoutes({ bareLayout = false }: { bareLayout?: boolean }) {
  const isMeetingDetailRoute = Boolean(useRouteMatch("/pages/meetings/enrolled/:meeting_id"));
  // The booking flow (pick a slot → fill in details → success) has its OWN contextual header
  // (`BookWidget`'s step title/back-link, `MeetingBookSuccessPage`'s own heading) — the generic
  // "meetings.heading" title + the 4 listing tabs (New/Upcoming/Completed/All) don't belong mid-flow,
  // same reasoning as the existing detail-route exception above.
  const isBookRoute = Boolean(useRouteMatch("/pages/meetings/book"));
  const isBookSuccessRoute = Boolean(useRouteMatch("/pages/meetings/booked/:meeting_id/success"));
  const isBookingFlowRoute = isBookRoute || isBookSuccessRoute;

  return (
    <MeetingsLayout displayHeader={!isMeetingDetailRoute && !isBookingFlowRoute} bareLayout={bareLayout}>
      <RedesignMeetingsProvider value={bareLayout}>
        <Switch>
          <Route path="/pages/meetings/enrolled/:meeting_id" component={MeetingDetailPage} />
          <Route path="/pages/meetings/enrolled" component={MeetingsEnrolledPage} />
          <Route path="/pages/meetings/booked/:meeting_id/success" component={MeetingBookSuccessPage} />
          <Route path="/pages/meetings/book/:expert_id" component={MeetingBookPage} />
          <Route exact path="/pages/meetings" component={MeetingsPage} />
          {/* Any UNMATCHED sub-path (e.g. /pages/meetings/book with no id, or a typo) must NOT greedily
              render the listing at the wrong URL — redirect it to the section index. When the redesign
              route override is on, that index re-enters the top <Switch> and renders the REDESIGN listing;
              when off, the legacy listing. This is the routing convention: a nested route group redirects
              unmatched sub-paths to its index rather than falling through to a greedy catch-all. */}
          <Redirect to="/pages/meetings" />
        </Switch>
      </RedesignMeetingsProvider>
    </MeetingsLayout>
  );
}

export default requireOfferSign(MeetingsRoutes);
